module.exports = __webpack_public_path__ + "static/assets/7da13dba77101e836210d5d9413fd7b1.svg";